import * as React from 'react'

import { AutoToBankLinkingScreen } from '@ally/transmitigator'
import { Space, TextBody } from '@ally/metronome-ui'
import { LoginHeading } from '@ally/ally-login'
import { Private } from '@ally/private'

import { StyledTextBody } from '../Shared'
import { useTransmit } from '../../TransmitContext'
import { getDisplayRole } from '../../Utils'
import { useHostServices } from '../../HostServices'
import {
  AccountLinkingContainer,
  AccountLinkingContentWrapper,
  AccountLinkingScreen,
  AccountLinkingStepper,
  AccountLinkingStepperWrapper,
} from '.'
import { EnterpriseLoginForm } from './EnterpriseLoginForm'

const AutoToBankLinkingContent: React.FC<Pick<
  AutoToBankLinkingScreen['payload'],
  | 'status'
  | 'autoUsername'
  | 'userSoftLinkedRelationships'
  | 'enterpriseUsername'
  | 'firstName'
>> = ({
  status,
  autoUsername,
  userSoftLinkedRelationships,
  enterpriseUsername,
  firstName,
}) => {
  const { analytics } = useHostServices()

  React.useEffect(() => {
    analytics.trackPageView({
      eventType: 'pageview',
      pageName: 'AOS:Login:Link Bank Account',
    })
  }, [])

  return (
    <AccountLinkingContainer>
      <AccountLinkingContentWrapper>
        <LoginHeading title="Your Auto login info is no longer valid." />

        <Space mb="lg">
          <StyledTextBody size="sm" tag="p">
            <Private as="span">{firstName}</Private>, your accounts are now in
            one place, so you&apos;ll have more to see with less to remember.
            Enter your Ally{' '}
            <TextBody size="sm" tag="span" weight="bold">
              {getDisplayRole(userSoftLinkedRelationships)}
            </TextBody>{' '}
            password to start connecting your accounts.
          </StyledTextBody>
        </Space>

        <EnterpriseLoginForm
          enterpriseUsername={enterpriseUsername as string}
          userRoles={userSoftLinkedRelationships}
          status={status}
        />
      </AccountLinkingContentWrapper>
      <AccountLinkingStepperWrapper>
        <AccountLinkingStepper
          screen={AccountLinkingScreen.BankToAuto}
          userRelationships={userSoftLinkedRelationships}
        />
      </AccountLinkingStepperWrapper>
    </AccountLinkingContainer>
  )
}

export const AutoToBankLinking: React.FC = () => {
  const { activeScreen } = useTransmit()

  if (activeScreen.type !== 'AutoToBankLinking') {
    return null
  }

  // eslint-disable-next-line react/jsx-props-no-spreading
  return <AutoToBankLinkingContent {...activeScreen.payload} />
}
